import { styled } from '@linaria/react';

export const BetRowLeftBetContent = styled.div`
  height: calc(var(--ogm-grid-column-height) - 1px);
  display: flex;
  align-items: center;
  padding: 10px 0;
`;

export const BetRowLeftBetName = styled.span`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.36;
  color: var(--ogm-text-body);
  text-decoration: none;
`;

export const BetRowLeftBetNameLink = styled.a`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.36;
  color: var(--ogm-text-body);
  text-decoration: none;
`;
